import React, { useState } from "react";
import './faqs.css';

const Faqs = () => {
  const [selectedFaq, setSelectedFaq] = useState(1);

  const faqs = [
    {
      id: 1,
      question: "What is the purpose of this website?",
      answer: "This website is a carpooling app that connects drivers with empty seats to passengers heading the same way. You can offer a ride if you're driving, or book a seat on someone else's ride."
    },
    {
      id: 2,
      question: "How do I create an account?",
      answer: "Sign up with your email and a password, or use your Google account. You'll receive a verification email — click the link to activate your account before you can post or book rides."
    },
    {
      id: 3,
      question: "How do I offer a ride?",
      answer: "Go to Publish, fill in your departure city, arrival city, route, date and time, available seats (1-6), and fare, then tap 'Offer Ride'. The departure and arrival cities must be different, and the date must be in the future."
    },
    {
      id: 4,
      question: "Can I post multiple ride offers at once?",
      answer: "No. You can only have one active ride offer at a time. To post a new offer, you need to either start or delete your current one first."
    },
    {
      id: 5,
      question: "How do I request a ride?",
      answer: "If you can't find a ride that suits you, go to Publish, switch to 'Request', fill in your departure and arrival cities along with your preferred date and time, then tap 'Request Ride'."
    },
    {
      id: 6,
      question: "Can I have a ride offer and a ride request at the same time?",
      answer: "Yes. The one-at-a-time rule applies separately — you can have one active ride offer and one active ride request simultaneously."
    },
    {
      id: 7,
      question: "How do I book a seat on someone's ride?",
      answer: "Find a ride on the feed, tap it to view details, and hit the 'Book' button. The ride must have available seats and must not have already started or been completed."
    },
    {
      id: 8,
      question: "Can I cancel my booking?",
      answer: "Yes, you can unbook anytime before the ride starts. Once the driver marks the ride as 'In Transit', your booking is locked in and cannot be cancelled."
    },
    {
      id: 9,
      question: "What happens when a ride is started?",
      answer: "Once the driver starts the ride, its status changes to 'In Transit'. At this point, no new passengers can book, existing passengers cannot unbook, and the ride cannot be deleted — it can only be completed."
    },
    {
      id: 10,
      question: "Can I delete my ride?",
      answer: "You can delete a ride only if it hasn't been started yet. If passengers have already booked, you'll see a confirmation prompt before deletion. Rides that are 'In Transit' or 'Completed' cannot be deleted."
    },
    {
      id: 11,
      question: "What happens to passengers if I delete my ride?",
      answer: "All booked passengers will be notified that the ride has been cancelled. Frequent cancellations with passengers are tracked on your profile."
    },
    {
      id: 12,
      question: "What does 'Completed' mean?",
      answer: "Once the driver marks a ride as complete, it becomes a permanent record. Completed rides cannot be deleted or modified, and they appear with a 'Done' badge on your listing."
    },
    {
      id: 13,
      question: "How can I reset my password?",
      answer: "Tap 'Forgot Password?' on the login page to receive a reset link via email. The link is valid for 15 minutes. Click it, enter your new password, and you're good to go."
    },
    {
      id: 14,
      question: "Why am I unable to post rides or book seats?",
      answer: "This can happen if your account is temporarily banned, your email isn't verified, or you already have an active offer/request. Check your profile status or delete your existing ride first."
    },
    {
      id: 15,
      question: "Is my personal information secure?",
      answer: "Yes. Your password is hashed and never stored in plain text. Sessions are encrypted, and your personal data is only visible to relevant ride participants."
    },
  ];

  const handleFaqClick = (id) => {
    setSelectedFaq(selectedFaq === id ? null : id);
  };

  return (
    <div className="sr-faqs">
      <div className="sr-faqs__top">
        <h1 className="sr-faqs__title">FAQs</h1>
        <p className="sr-faqs__subtitle">Frequently asked questions</p>
      </div>

      <div className="sr-faqs__body">
        <div className="sr-faqs__container">
          {faqs.map((faq) => (
            <div key={faq.id} className="sr-faqs__item" onClick={() => handleFaqClick(faq.id)}>
              <h2>{faq.question}</h2>
              {selectedFaq === faq.id && <p>{faq.answer}</p>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Faqs;
